export const getProjectById = (state, projectId) => {
    return state.projects[projectId];
};
